window.Proposal = {
	
	togglePublicLink: function(type, id, publiclinkavailable){
	
		MyFacture.post("proposal_proposal", {action:'togglePublicLink', type:type, id:id, publiclinkavailable:publiclinkavailable}, function(data){
					
			if (data.publicLinkAvailable){
				switch (data.publicLinkAvailable){
					
					case "Y":
						$('.publicLinkToggle.toggleOff').show();
						$('.publicLinkToggle.toggleOn').hide();
						break;
						
					case "N":
						$('.publicLinkToggle.toggleOff').hide();
						$('.publicLinkToggle.toggleOn').show();
						break;
				}
			}

		}, "json");
		
	},
	
	initOverview : function(proposalType, proposalid){
		
		MyTabs.initVertical('overviewTabs', {
			callback: function (item) {
				MyFacture.post('staff', {action: 'saveTab', linkedtype: 'proposal', 'linkedid': proposalid, openedTab: item.attr('id')});
			}
		});
		
		$.post('/?_f=proposal_proposal', {action : "statisticsTotals", proptype : proposalType, propid : proposalid}, function(data){
			$('#totalContent .span_12').html(data.stats);
		}, 'json');
	
	},
	
	loadAgendaTab : function(startTime, endTime, days, view){
		if($('#proposal-fullcalendar table').length === 0) {
			setTimeout(function() {
				
				$('#calendar').fullCalendar('destroy');
				MyFacture.customForm();
				Agenda.initCalendar(startTime, endTime, days, view);

			}, 500);
			
		}
	},	
	
	copy : function(type, parentID){
		var formID = 'proposalCreateForm';

		if(type === 'proptemplate'){
			Utils.relocate('/?_f=proposal_builder&type='+type+'&copy='+parentID);
		}else{
			var data = {
				action		: 'createForm',
				type		: type,
				parentID	: parentID,
				context		: 'copy',
			};
			
			
			var options = {
				title: Loc.g('Copie de document redactor'),
				buttons:
						[
                            {
                                text: Loc.g("Annuler"),
                                click: function () {
                                    $(this).dialog("close");
                                }
                            },
                            {
								text: Loc.g("Continuer"),
								click: function () {
									$("#" + formID).submit();
								}
							}
						],
				width: 800,
				callback: function () {
					var params = {parentID : parentID};
					Proposal.prepareCreateForm(formID, params);
				}
			};

			MyWindow.load('proposal_proposal', data, options);
		}
	},
	
	create : function(type, params){

		var params		= params == undefined ? {parentID : 0} : params;
		var parentID	= params.parentID == undefined ? 0 : params.parentID;

		var docID		    = ($('input#docid').length > 0)		    ? $('input#docid').val()	        : 0;
		var docType		    = ($('input#doctype').length > 0)	    ? $('input#doctype').val()	        : 'none';
		var thirdID		    = ($('input#thirdid').length > 0)	    ? $('input#thirdid').val()	        : 0;
        var opportunityID   = ($('input#opportunityid').length > 0) ? $('input#opportunityid').val()	: 0;

		var context = 'creation';
		if(parentID != 0){
			context = 'conversion';
		}
		
		var params = {
			parentID		: parentID,
			currentDocID	: docID,
			currentDocType	: docType,
			thirdID			: thirdID,
			opportunityID   : opportunityID
		}
		
		var data = $.extend({
			action		: 'createForm',
			type		: type,
			context		: context
		}, params);
				
		var title = Loc.g('Nouveau document redactor');
		
		if(type === 'proptemplate'){
			title = Loc.g('Nouveau modèle redactor');
		}
		
		if(parentID !== 0){
			title = Loc.g('Conversion d‘un modèle redactor');
		}
		
		var formID = 'proposalCreateForm';
		
		var options = {
			dialogClass : "white",
			title: title,
			width : MyWindow.large,
			buttons:
					[
                        {
                            text: Loc.g("Annuler"),
                            click: function () {
                                $(this).dialog("close");
                            }
                        },
                        {
							text: Loc.g("Continuer"),
							click: function () {
								$("#" + formID).submit();
							}
						}
					],
			width: 800,
			callback: function () {
				
				Proposal.prepareCreateForm(formID, params);
			}
		};

		MyWindow.load('proposal_proposal', data, options);
	},
	
	
	prepareCreateForm: function (formID, params) {

		params = typeof params == undefined ? {} : params;
		params.doctypes = ($('input#doctypes').length > 0) ? $('input#doctypes').val() : '';

		params = $.extend({
			parentID : 0,
			currentDocID : 0,
			currentDocType : 'none',
			thirdID : 0,
			doctypes: 'estimate|invoice|delivery|order|creditnote'
		}, params);
		
		
		var formOpts = {
			data: $.extend({action: 'recordCreateForm'}, params),
			dataType: 'json',
			success: function (data) {
				var formOk = MyForm.processJson(data, formID);

				$('.selectdisabled').attr('disabled', true);
			}
		};

		MyForm.prepare(formID, 'proposal_proposal', formOpts, true);

		$('select[name=linkedtype]', '#'+formID).bind("change", function () {
			var val = $(this).val();

			var selRelatedType = $('select[name=relatedtype]');
			selRelatedType.find('option[disabled]').removeAttr('disabled');

			if (val == 'supplier') {
				selRelatedType.find('option[value=rent], option[value=document], option[value=opportunity]').attr('disabled', true);

				if (selRelatedType.val() == 'document' || selRelatedType.val() == 'opportunity' || selRelatedType.val() == 'rent') {
					selRelatedType.val('none').trigger('change');
				}
			} else if (val == 'prospect') {
				selRelatedType.find('option[value=rent]').attr('disabled', true);
				if (selRelatedType.val() == 'rent') {
					selRelatedType.val('none').trigger('change');
				}
			}

			$(this).closest('.form-group').find('.token-input-list').remove();

			if($(this).attr('isSet') == undefined){
				$(this).attr('isSet', true);
			} else {
				var selHiddenAutocompleteRelatedType = $(this).parent().children('.hidden').length > 0 ? $(this).parent().children('.hidden') : null;
				selHiddenAutocompleteRelatedType && selHiddenAutocompleteRelatedType.remove();
			}
			

			if ($('#token-input-relatedid').length > 0) {
				$('#relatedid', '#'+formID).tokenInput('more', "");
			}

			
			if (val == 'client') {
				val = 'third';
			}
			if($('#prop_linkedid', '#'+formID).length > 0) {
				$('#prop_linkedid', '#' + formID).show();
				TokenInput.autoContactListing('#prop_linkedid', val, 1, true, '',
					function(item) {
						var more = item.id.replace(new RegExp('corporation_', 'g'), 'third_');
						if ($('#token-input-relatedid').length > 0) {
							$('#relatedid', '#' + formID).tokenInput('more', more);
						}
					},
					function(item) {
						if ($('#token-input-relatedid').length > 0) {
							$('#relatedid', '#' + formID).tokenInput('more', "");
						}
					}
				);
			}
			if (val === 'none') {
				$(this).closest('.form-group').find('.token-input-list').css('pointer-events', 'none')
				$('#token-input-prop_linkedid', '#' + formID).css('background', '#f6f6f9')
			}
		});

		$('select[name=relatedtype]', '#'+formID).bind("change", function () {
			var val = $(this).val();

			$(this).closest('.form-group').find('.token-input-list').remove();

			var more = '';
			var linked = $('#prop_linkedid', '#'+formID).val();

			var selLinkedType = $('select[name=linkedtype]');

			selLinkedType.find('option[disabled]').removeAttr('disabled');
			if (val == 'rent') {
				selLinkedType.find('option[value=prospect], option[value=supplier]').attr('disabled', true);

				if (linked == 'prospect' || linked == 'supplier') {
					selLinkedType.val('none').trigger('change');
				}

			} else if (val == 'document' || val == 'opportunity') {
				selLinkedType.find('option[value=supplier]').attr('disabled', true);
				if (linked == 'supplier') {
					selLinkedType.val('none').trigger('change');
				}
			}

			if($(this).attr('isSet') == undefined){
				$(this).attr('isSet', true);
			} else {
				var selHiddenAutocompleteLinkedType = $(this).parent().children('.hidden').length > 0 ? $(this).parent().children('.hidden') : null;
				selHiddenAutocompleteLinkedType && selHiddenAutocompleteLinkedType.remove();
			}



			if($('#relatedid', '#'+formID).length > 0){
				
				switch (val) {
					case 'none':
						$('#relatedid', '#' + formID).show();
						TokenInput.autoItem('#relatedid', val, '',1)
						$(this).closest('.form-group').find('.token-input-list').css('pointer-events', 'none')
						$('#token-input-relatedid', '#' + formID).css('background', '#f6f6f9')
						break;
					case 'document' :
						$('#relatedid', '#'+formID).show();
						more = linked.replace(new RegExp('corporation_', 'g'), 'third_');
						if(more.indexOf('third') == -1){
                            more = 'third_'+more;
						}
						TokenInput.autoDocumentListing('#relatedid', params.doctypes , 1, true, more,
								function (item) {
									if ($('#token-input-prop_linkedid').length > 0) {
										$('#linkedtype', '#'+formID).val(item.relationType).trigger('change');
										$('#prop_linkedid', '#'+formID).tokenInput('clear');
										$('#prop_linkedid', '#'+formID).tokenInput('add', {name: item.thirdname, id: item.thirdid});
									} else {
										$('#linkedtype', '#'+formID).val(item.relationType).trigger('change');
										$('#prop_linkedid', '#'+formID).tokenInput('add', {name: item.thirdname, id: item.thirdid});
									}
								});
						break;
					case 'opportunity' :
						$('#relatedid', '#'+formID).show();
						more = linked.replace(new RegExp('corporation_', 'g'), '');
						TokenInput.autoOpportunity('#relatedid', function (item) {
							if ($('#token-input-prop_linkedid').length > 0) {
								$('#linkedtype', '#'+formID).val(item.relationType).trigger('change');
								$('#prop_linkedid', '#'+formID).tokenInput('clear');
								$('#prop_linkedid', '#'+formID).tokenInput('add', {name: item.linkedName, id: item.linkedId});
							} else {
								$('#linkedtype', '#'+formID).val(item.relationType).trigger('change');
								$('#prop_linkedid', '#'+formID).tokenInput('clear');
								$('#prop_linkedid', '#'+formID).tokenInput('add', {name: item.linkedName, id: item.linkedId});
							}
						}, more, 1);
						break;
					case 'item' :
						$('#relatedid', '#'+formID).show();
						TokenInput.autoItem('#relatedid', 'item|service', '', 1);
						break;

					case 'rent' :
						$('#relatedid').show();
						more = linked.replace(new RegExp('corporation_', 'g'), '');
						TokenInput.autRental('#relatedid', '', 1, more, function (item) {
							if ($('#token-input-prop_linkedid').length > 0) {
								$('#linkedtype').val('client').trigger('change');
								$('#prop_linkedid', '#'+formID).tokenInput('clear');
								$('#prop_linkedid', '#'+formID).tokenInput('add', {name: item.thirdname, id: item.thirdid});
							} else {
								$('#linkedtype', '#'+formID).val('client').trigger('change');
								$('#prop_linkedid', '#'+formID).tokenInput('clear');
								$('#prop_linkedid', '#'+formID).tokenInput('add', {name: item.thirdname, id: item.thirdid});
							}
						});
						break;
					case 'ticket' :
						$('#relatedid', '#'+formID).show();
						more = linked.replace(new RegExp('corporation_', 'g'), '');
						TokenInput.autoSupport('#relatedid', function (item) {
							if ($('#token-input-prop_linkedid').length > 0) {
								$('#linkedtype', '#'+formID).val('client').trigger('change');
								$('#prop_linkedid', '#'+formID).tokenInput('clear');
								if (item.thirdid != '' && item.thirdid != 0) {
									$('#prop_linkedid').tokenInput('add', {name: item.thirdName, id: item.thirdid});
								}
							} else {
								$('#linkedtype', '#'+formID).val('client').trigger('change');
								$('#prop_linkedid', '#'+formID).tokenInput('clear');
								if (item.thirdid != '' && item.thirdid != 0) {
									$('#prop_linkedid', '#'+formID).tokenInput('add', {name: item.thirdName, id: item.thirdid});
								}
							}
						}, more, 1);
						break;
				}
			}

		});

		$('select[name=relatedtype]', '#'+formID).trigger('change');
		$('select[name=linkedtype]', '#'+formID).trigger('change');

		MyFacture.customForm('#' + formID);
	},
	
	
	remove : function(proposalType, proposalID){
		var options = {
			buttons:
					[
						{
							"class": "btn btn-default",
							text: Loc.g("Non"),
							click: function () {
								$(this).dialog("close");
							}
						},
						{
							"class": "btn btn-primary",
							text: Loc.g("Oui"),
							click: function () {
								
								MyFacture.post('proposal_proposal', {id : proposalID, type : proposalType, action : 'delete'},
									function(data){
										if(data.status == 'ok'){
											Utils.relocate('/?_f=proposal_'+(proposalType == 'propdocument' ? 'documents' : 'templates'));
										}else{
											MyWindow.alert(Loc.g('Problème lors de la suppression.'), {type : 'warning'});
										}
									},
								'json');
							}
						}
					],
			width: 300,
			type : 'warning',
		};
		
		MyWindow.alert((proposalType == 'propdocument' ? Loc.g('Supprimer ce document') : Loc.g('Supprimer ce modèle')), options);
	},
	
	sendByEmail : function(proposalID, proposalType, thirdID){
		var formID = 'emailForm';
		
		
		var options = {
			title: Loc.g('Envoyer par email'),
			buttons:
					[
                        {
                            text: Loc.g("Annuler"),
                            click: function () {
                                $(this).dialog("close");
                            }
                        },
                        {
							text: Loc.g("Envoyer"),
							click: function () {
								$("#" + formID).submit();
							}
						}
					],
			width: 800,
			callback : function(){
				MyFacture.customForm('#'+formID);
				
				var formData = {
					dataType : 'json',
					data	 : {
						action : 'sendEmail', 
						proposalID : proposalID, 
						proposalType : proposalType
					},
					success : function(data){
						var formIsOk = MyForm.processJson(data, "templateForm");
							
						if (formIsOk) {
							Utils.reload();
						}

					}
				};
				
				MyForm.prepare(formID, 'proposal_email', formData, true);
				Email.displaySchedule();
			}
		}
		
		MyWindow.load('proposal_email', {action : 'emailForm', proposalID : proposalID, proposalType : proposalType, thirdID :thirdID}, options);
	},
	
	sendByMail : function(proposalID, proposalType, hasAddress){
		if(hasAddress == 'N'){
			MyWindow.alert(Loc.g("Votre document ne dispose pas d'adresse. Editez-le pour en ajouter une."), {type : 'warning'});
		}else{
			var formid		= "mailSendForm";
			var sendTest	= undefined == sendTest ? "N" : sendTest;
			
			var options = {
				title	: Loc.g("Envoi par courrier postal"),
				width	: 570,
				buttons	: [
                    {text: Loc.g("Annuler"), click: function () {
                        $(this).dialog("close");
                    }},
                    {
						text: Loc.g("Envoyer"),
						click: function () {
							var myButton = $(this).parent().find('button:contains("Envoyer")');
							myButton.button('disable');
							myButton.unbind('click');
							$("#" + formid).submit();
						}
					}
				],
				callback: function () {
					Mail.initPriceEngine();
					$('#mailSendForm :checkbox:first').trigger('change');

					if (sendTest == 'Y') {
						var formOpts = {
							success: function (data) {
								
								var formIsOk = MyForm.processJson(data, formid);
								if (formIsOk){
									MyWindow.close();
									
									var alertOpts = {
										type : 'confirm', 
										buttons : [
											{
												text : Loc.g('Fermer'), 
												click : function(){Utils.reload();}
											}
										]
									};
									
									MyWindow.alert(Loc.g('Le courrier a bien été envoyé'), alertOpts);
								}else if(data.form.msg != ''){
									MyWindow.alert(data.form.msg, {type: "error"});
								}
							}, 
							dataType: "json"
						};
						MyForm.prepare("mailSendForm", "proposal_proposal", formOpts, true);
					}

					if ($('#mailSendForm input[name=sendable]').val() == 'N') {
						$('#mailSendForm').unbind('submit').bind('submit', function () {
							Mail.incompleteAddresses();
							return false;
						})
					}
					
					MyFacture.customForm('#mailSendForm');
				}
			};
			MyWindow.load("proposal_proposal", {action: "sendMailForm", linkedid: proposalID, linkedtype: proposalType}, options);			
		}
	},
	
	switchSubActions : function(name){
		$('#action-'+name).find('.subActions').slideToggle();
	},
	
	changeStep : function(proposalID, proposalType, step){
		
		$.ajax({
			type		: 'POST',
			url			: '/?_f=proposal_proposal', 	
			data		: {action : 'changeStep', proposalID : proposalID, proposalType : proposalType, step : step},
			beforeSend	: function(){
				MyFacture.startWait();
			},
			success : function(data){
				Utils.reload();
			},
			dataType : 'json',
		});
	},
	
	prefillcreate : function(item){
		const linkedTypeElementSelect = $('select[name=linkedtype]');
		const relatedTypeElementSelect = $('select[name=relatedtype]');
		
		if(linkedTypeElementSelect.val() !== item.linkedtype) {
			$('input[name=linkedtype]').remove();
			linkedTypeElementSelect.after('<input type="hidden" name="linkedtype" value="' + item.linkedtype + '" />');
			linkedTypeElementSelect.val(item.linkedtype);
			item.linkedtype !== 'none' ? linkedTypeElementSelect.trigger('change').attr('disabled', 'disabled').addClass('selectdisabled') : linkedTypeElementSelect.trigger('change');
		}

		if(relatedTypeElementSelect.val() !== item.relatedtype){
			$('input[name=relatedtype]').remove();
			relatedTypeElementSelect.after('<input type="hidden" name="relatedtype" value="'+item.relatedtype+'" />');
			relatedTypeElementSelect.val(item.relatedtype);
			item.relatedtype !== 'none' ? relatedTypeElementSelect.trigger('change').attr('disabled', 'disabled').addClass('selectdisabled') : relatedTypeElementSelect.trigger('change');
		}
	},
	
	prefilldelete : function(item){
		
		$('input[name=linkedtype]').remove();
		$('select[name=linkedtype]').removeAttr('disabled').removeClass('selectdisabled');
		
		
		$('input[name=relatedtype]').remove();
		$('select[name=relatedtype]').removeAttr('disabled').removeClass('selectdisabled');
	},
	
	loadStats : function(proposalType, proposalID){
		
		$.ajax({
			url		: '/?_f=proposal_proposal',
			type	: 'POST',
			data	: {
				action		:  'statistics',
				propid		: proposalID,
				proptype	: proposalType,
			},
			dataType: 'json',
			success : function(data){
				$('#viewstats_content').html(data.stats);
			}
		})
	},
	
	updateArchive : function(proptype, propid, archive){
		var options = {
			buttons:
					[
						{
							"class": "btn btn-default",
							text: Loc.g("Non"),
							click: function () {
								$(this).dialog("close");
							}
						},
						{
							"class": "btn btn-primary",
							text: Loc.g("Oui"),
							click: function () {
								
								MyFacture.post('proposal_proposal', {id : propid, type : proptype, archive : archive, action : 'archive'},
									function(data){
										if(data.status == 'ok'){
											Utils.reload();
										}else{
											MyWindow.alert(Loc.g('Problème lors de l‘archivage.'), {type : 'warning'});
										}
									},
								'json');
							}
						}
					],
			width: 300,
			type : 'warning',
		};
		
		MyWindow.alert((archive === 'Y' ? Loc.g('Archiver ce ') : Loc.g('Désarchiver ce '))+(proptype === 'propdocument' ? Loc.g('document') : Loc.g('modèle')), options);
		
	}
	
};


window.Proposals = {
		prepareFilterForm: function (listingname, type) {
		var options = {success: function (data) {
				Proposals.processFilterForm(data, listingname);
			}, dataType: "json"};
		MyForm.prepare(listingname+"FilterForm", "proposal_"+type+"s&updateListing", options);
	},
	
	processFilterForm: function (data, listingname) {
		Listing.refresh(listingname+"Listing", data, eval('data.'+data.metadatasName));
	}
};


window.ProposalPrefs = {
	
	updateBackground : function(data){

		if(data.success === true){
			$('.bgpreview').find('img').attr('src', data.file);
            $('.bgpreview').find('img').show();
			$('#layout_bgfile').val(data.filename);
			$('.bgplaceholder').hide();
		}
	},

    removeBackground : function(){
		var params	= [];
        MyFacture.post('proposal_prefs&action=removeLayout', params, function(data){
        	$("#proposalBgPreview .bgpreview img").attr('src', '');
        	$("#proposalBgPreview #layout_bgfile").attr('value', '');
            $('.bgplaceholder').show();
        }, "json");
	}
	
};

window.ProposalTracking = {
	start	: null,
	
	init	: function (proposaltype, proposalid) {

		var url = location.protocol + '//' + location.hostname + '/?_f=proposal_externalOverview';

		var date = new Date();
		ProposalTracking.start = Math.floor(date.getTime() / 1000);
		
		$(window).bind('unload', function(event){
			
			var date		= new Date();
			var current		= Math.floor(date.getTime() / 1000);
			var duration	= (current - ProposalTracking.start);
			
			var data =  {
				action		: 'recordtracking',
				propaltype	: proposaltype,
				propalid	: proposalid,
				duration	: duration,
				start		: ProposalTracking.start,
				end			: current
			};
			
			$.ajax({
				type	: 'POST',
				url		: url,
				data	: data,
				async	: false
			});
		});
	},
	
	download : function(proposaltype, proposalid){
		var url = location.protocol + '//' + location.hostname + '/?_f=proposal_externalOverview';

		var data = {
			action		: 'trackDownload',
			propaltype	: proposaltype,
			propalid	: proposalid
		};

		$.ajax({
			type: 'POST',
			url: url,
			data: data,
			async: false
		});
	}
};